import { EditIcon } from 'assets/images/svg';
import { useManagePermittedRoles } from 'library/hooks';
import { useState } from 'react';
import ManageTeamsModal from 'zComponents/molecules/ManageTeamsModal';

import { Button, Col, Row, Tooltip } from 'zui/Antd';

const PermissionsPanelExtra = ({ personID, activeKeys, setActiveKeys, onModalOpenChange }) => {
	const canManageMembers = useManagePermittedRoles('manageMembers');
	const permissionDeniedMessage = "You don't have permission to perform this action.";

	const [openModal, setOpenModal] = useState(false);

	const handleOpenModal = (e) => {
		e.stopPropagation();
		if (!canManageMembers) return;
		setOpenModal(true);
		onModalOpenChange?.(true);
		if (!activeKeys.includes('teams')) {
			setActiveKeys([...activeKeys, 'teams']);
		}
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		onModalOpenChange?.(false);
		setTimeout(() => {
			setActiveKeys((prev) => {
				if (!prev.includes('teams')) {
					return [...prev, 'teams'];
				}
				return prev;
			});
		}, 10);
	};

	return (
		<Row align='middle' gutter={[8, 8]}>
			<Col>
				<Tooltip title={!canManageMembers ? permissionDeniedMessage : ''}>
					<span>
						<Button
							type='text'
							size='small'
							icon={<EditIcon color='currentColor' />}
							onClick={handleOpenModal}
							disabled={!canManageMembers}
						/>
					</span>
				</Tooltip>
			</Col>
			<ManageTeamsModal visible={openModal} setVisible={handleCloseModal} personID={personID}>
				<div />
			</ManageTeamsModal>
		</Row>
	);
};

export default PermissionsPanelExtra;
